export const nowAsEpoch = () => Math.floor(Date.now() / 1000);

export const computeStartEndForContract = (contract) => {
    const start = +contract.date_start;
    const end = contract.exit_tick_time
        ? +contract.exit_tick_time
        : contract.date_expiry
            ? +contract.date_expiry
            : nowAsEpoch();
    return { start, end };
};

export const stripLoginId = (options) => {
    if (!options || typeof options !== 'object') return options;
    const { loginid, symbol, ...rest } = options;
    if (symbol && !rest.underlying_symbol) {
        rest.underlying_symbol = symbol;
    }
    return rest;
};

export const migrateProposalOptions = (options) => {
    if (!options || typeof options !== 'object') return options;
    const {
        loginid, barrier_range, product_type,
        date_start, trade_risk_profile, trading_period_start,
        symbol,
        ...rest
    } = options;

    if (symbol && !rest.underlying_symbol) {
        rest.underlying_symbol = symbol;
    }

    return rest;
};
